import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule, Routes} from '@angular/router';
import { MainComponent } from './main.component';

import { MatSidenavModule } from '@angular/material';
import { VasatModule } from 'vasat-ng';
import { FdmQMAPModule } from '../commons/qmap/qmap.module';
import { FdmFilesModule } from '../commons/files/files.module';


const Routes: Routes = [
  {
    path: 'folder/:folderId', component: MainComponent,
  },
  {
    path: 'folder', component: MainComponent,
  }



];

@NgModule({
  imports: [
    FdmQMAPModule,
    FdmFilesModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    VasatModule,
    MatSidenavModule,
    RouterModule.forChild(Routes)
  ],
  declarations: [
    MainComponent
  ],
  entryComponents: []

})

export class FileModule {


}
